import { NodeEnvironment } from "./types";

export function isDevelopmentNodeEnvironment() {
  return process.env.NODE_ENV === NodeEnvironment.DEVELOPMENT;
}

export function isTestNodeEnvironment() {
  return process.env.NODE_ENV === NodeEnvironment.TEST;
}

export function isProductionNodeEnvironment() {
  return process.env.NODE_ENV === NodeEnvironment.PRODUCTION;
}

/** App color scheme from env. Default: light. */
export type AppTheme = "light" | "dark" | "system";

/**
 * NEXT_PUBLIC_THEME=light|dark|system (default light).
 * Legacy: NEXT_PUBLIC_FORCE_LIGHT_THEME=true|false still works.
 */
export function getAppTheme(): AppTheme {
  const theme = process.env.NEXT_PUBLIC_THEME?.trim().toLowerCase();
  if (theme === "light" || theme === "dark" || theme === "system") {
    return theme;
  }

  const forceLight = process.env.NEXT_PUBLIC_FORCE_LIGHT_THEME?.trim().toLowerCase();
  if (forceLight === "false" || forceLight === "0") return "system";
  if (forceLight === "true" || forceLight === "1") return "light";

  return "light";
}

/** @deprecated Prefer getAppTheme() === "light" */
export function isForceLightTheme() {
  return getAppTheme() === "light";
}
